export class AddressType {
    id: number;
    type: string;
    isActive: boolean;
}
